import Table from "../components/table/Table";
import useUserTasks from "../hooks/useUserTasks";
import PaginationModule from "../components/pagination/PaginationModule";

function TasksViewer() {
  const {
    tasks,
    setTasks,
    loading,
    error,
    page,
    setPage,
    pageSize,
    totalPages,
    setPageSize
  } = useUserTasks();

  // 1. Error state
  if (error) {
    return (
      <p className="p-8 text-red-500 text-center text-xl">{error}</p>
    );
  }

  // 2. Loading state
  if (loading) {
    return (
      <div className="mt-10 text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Just a moment while we load your tasks...</p>
      </div>
    );
  }

  // 3. Normal content (when not loading and no error)
  return (
    <div className="mx-10 mt-4">
      <Table data={tasks} setTasks={setTasks} />
      <PaginationModule
        totalPages={totalPages}
        postsPerPage={pageSize}
        setPostsPerPage={setPageSize}
        currentPage={page}
        setCurrentPage={setPage}
      />
    </div>
  );
}

export default TasksViewer;